var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoyaltyLicensingAgreements(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4699 32.82H10.4499L7.66992 34.57L6.91992 40.96V48.16L9.89992 50.84H45.4699V32.82Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4699 41.91V10.09H11.3399C8.89992 10.09 6.91992 12.07 6.91992 14.51V46.45",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1799 51H43.2099C44.4599 51 45.4699 49.99 45.4699 48.74V41.91H11.1799C8.82992 41.91 6.91992 43.82 6.91992 46.17V46.74C6.91992 49.09 8.81992 51 11.1799 51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4699 1.36V32.82H16.5399L9.93992 33.09L6.91992 35.49V5.01L8.43992 2.09L11.3399 1L45.4699 1.36Z",
    fill: "#FFCF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4699 32.82V3.31C45.4699 2.04 44.4399 1 43.1599 1H11.3399C8.89992 1 6.91992 2.98 6.91992 5.42V37.36",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1799 41.91H45.4699V32.82H11.1799C8.82992 32.82 6.91992 34.73 6.91992 37.08V37.65C6.91992 40 8.81992 41.91 11.1799 41.91Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04012 42.58C8.41015 42.58 8.71012 42.28 8.71012 41.91C8.71012 41.54 8.41015 41.24 8.04012 41.24C7.67009 41.24 7.37012 41.54 7.37012 41.91C7.37012 42.28 7.67009 42.58 8.04012 42.58Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8199 19.49C34.7899 19.21 34.6699 18.82 34.4699 18.33C34.2599 17.84 33.9599 17.42 33.5699 17.07C33.1799 16.72 32.5899 16.36 31.8099 15.98C31.0299 15.6 30.0899 15.29 28.9899 15.05L28.0899 14.87V10.62C28.4999 10.72 28.8699 10.91 29.1899 11.21C29.6599 11.65 29.9099 12.19 29.9299 12.82H34.1199C33.9999 11.27 33.3399 10.08 32.1399 9.26C31.0699 8.53 29.7199 8.05 28.0799 7.84V5.94H27.4699H25.7299H25.1499V7.82C23.4699 7.99 22.0399 8.46 20.8599 9.24C19.5399 10.11 18.8799 11.31 18.8799 12.85C18.8799 13.61 19.0399 14.27 19.3499 14.82C19.6599 15.37 20.1299 15.82 20.7499 16.17C21.3699 16.52 21.9799 16.8 22.5799 17C23.1799 17.21 23.9099 17.4 24.7799 17.57C24.9199 17.6 25.0399 17.62 25.1499 17.65V22.62C24.4699 22.44 23.8899 22.14 23.4299 21.71C22.8399 21.16 22.5499 20.46 22.5699 19.61H18.3799C18.7899 23.12 21.0499 25.07 25.1499 25.47V27.54H25.7299H27.4699H28.0799V25.47C28.9599 25.39 29.7699 25.24 30.4999 25.01C31.3999 24.73 32.0999 24.41 32.6299 24.04C33.1499 23.67 33.5899 23.26 33.9399 22.81C34.2899 22.36 34.5299 21.95 34.6599 21.58C34.7899 21.21 34.8499 20.87 34.8499 20.57C34.8599 20.13 34.8499 19.78 34.8199 19.49ZM23.6899 13.73C23.2899 13.45 23.0799 13.04 23.0799 12.52C23.0799 11.89 23.3399 11.4 23.8599 11.06C24.2399 10.81 24.6699 10.66 25.1599 10.59V14.29C24.4999 14.14 23.9999 13.95 23.6899 13.73ZM29.7099 22.06C29.2299 22.36 28.6899 22.56 28.0899 22.67V18.34C28.9599 18.56 29.5999 18.79 29.9799 19.05C30.4399 19.37 30.6699 19.83 30.6699 20.43C30.6699 21.12 30.3499 21.66 29.7099 22.06Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyaltyLicensingAgreements);
export default __webpack_public_path__ + "static/media/RoyaltyLicensingAgreements.fa106cba40f65e4a9cf39531d3cdecc8.svg";
export { ForwardRef as ReactComponent };